const RangeSliders = () => {
  // We look for a wrapper that contains a group of sliders to balance
  const groups = document.querySelectorAll("[data-range-group]");

  groups.forEach((group) => {
    const containers = group.querySelectorAll("[data-range]");
    const inputs = Array.from(group.querySelectorAll('input[type="range"]'));
    const totalDisplay = group.querySelector("[data-range-total]");

    inputs.forEach((input) => {
      input.addEventListener("input", (e) => {
        let currentVal = parseInt(e.target.value);

        // 1. Calculate the sum of all OTHER sliders in this group
        const otherSum = inputs
          .filter((i) => i !== e.target)
          .reduce((sum, i) => sum + parseInt(i.value), 0);

        // 2. Cap the current slider if it exceeds the remaining budget
        if (currentVal + otherSum > 100) {
          currentVal = 100 - otherSum;
          e.target.value = currentVal;
        }

        // 3. Update all UI elements in the group
        updateGroupUI(inputs, totalDisplay);
      });
    });
  });

  // Helper to update text labels, progress bars, and total sum
  function updateGroupUI(inputs, totalDisplay) {
    let total = 0;

    inputs.forEach((input) => {
      const container = input.closest("[data-range]");
      const output = container.querySelector("[data-range-output]");
      const val = parseInt(input.value);

      total += val;

      // Update the text label (e.g., "30%")
      if (output) output.textContent = `${val}%`;

      // Update CSS Variable for custom styling/progress bars
      const progress = ((val - input.min) / (input.max - input.min)) * 100;
      input.style.setProperty("--value", progress + "%");
    });

    // Update the master total display if it exists
    if (totalDisplay) totalDisplay.textContent = total;
  }
};

export { RangeSliders };
